import removeSpaces from "./removeSpaces";


const formatNBTVA = (value: string) => {
	if (!value) return '';
	
	const char = removeSpaces(value);
	
	let formatedNBTVA = '';
	for (let i = 0; i < char.length; i++) {
		if (i === 2 || i === 4 ) {
			formatedNBTVA += ' ';
		}
		formatedNBTVA += char[i];
	}
	
	return formatedNBTVA;
};

export default formatNBTVA;
